import { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useRegistration } from '../hooks/useRegistration';
import { useI18n } from '../i18n';
import { PublicTabs } from './PublicTabs';
import { BrandMark } from './BrandMark';

export function RegisterPage() {
  const [searchParams] = useSearchParams();
  const [inviteToken, setInviteToken] = useState('');
  const { register, isLoading, error } = useRegistration();
  const { t } = useI18n();

  useEffect(() => {
    // Try to get invite token from URL
    const token = searchParams.get('token');
    if (token) {
      setInviteToken(token);
    }
  }, [searchParams]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (inviteToken.trim()) {
      await register(inviteToken.trim());
    }
  };

  return (
    <div className="min-h-screen">
      <PublicTabs />
      <div className="page-shell flex items-center justify-center py-10 sm:py-14">
        <div className="card-elevated max-w-xl w-full">
          <div className="mb-8 text-center">
            <BrandMark withWordmark size="lg" className="mx-auto mb-5" />
            <div className="section-eyebrow mb-2">{t('register.heroEyebrow')}</div>
            <h1 className="page-title mb-3">{t('register.heroTitle')}</h1>
            <p className="page-subtitle mx-auto max-w-md">
              {t('register.subtitle')}
            </p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-6">
            <div className="card-soft">
              <label htmlFor="invite" className="mb-2 block text-sm font-medium text-[color:var(--text-strong)]">
                {t('register.inviteTokenLabel')}
              </label>
              <input
                id="invite"
                type="text"
                value={inviteToken}
                onChange={(e) => setInviteToken(e.target.value)}
                placeholder={t('register.inviteTokenPlaceholder')}
                className="input"
                disabled={isLoading}
                required
              />
              <p className="mt-3 text-sm text-[color:var(--text-muted)]">
                {t('register.inviteTokenHint')}
              </p>
            </div>

            {error && (
              <div className="rounded-2xl border border-red-200 bg-red-50/90 p-4">
                <p className="text-sm text-red-800">{error}</p>
              </div>
            )}

            <button
              type="submit"
              disabled={isLoading || !inviteToken.trim()}
              className="btn btn-primary w-full"
            >
              {isLoading ? t('register.registering') : t('register.register')}
            </button>
          </form>

          <div className="mt-8 border-t border-[color:var(--border-soft)] pt-6">
            <p className="text-center text-sm text-[color:var(--text-muted)]">
              {t('register.alreadyRegistered')}{' '}
              <a href="/import" className="font-medium text-primary-600 hover:text-primary-700">
                {t('register.importKeys')}
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
